import { Grid } from "@mui/material";
import CountryWiseMembers from "./CountryWiseMembers";
import { useEffect, useState } from "react";
import IndividualAnalysisMembers from "./IndividualAnalysisMembers";
import SkillWiseMembers from "./SkillWiseMembers";
import {
  IindustryWiseMemberResult,
  IMemberWiseTableResults,
} from "features/dashboard/api/types";
import {
  GetIndustryWiseMember,
  GetMemberWiseTables,
} from "features/dashboard/api/hooks";
import IndustryWiseMembers from "../QuickLinks&Industry/IndustryWiseMembers";

const MemberWiseTables = () => {
  const [data, setData] = useState<IMemberWiseTableResults>();

  const [data1, setData1] = useState<IindustryWiseMemberResult>();

  const memberQuery = GetMemberWiseTables();

  const memberQuery1 = GetIndustryWiseMember();

  useEffect(() => {
    if (memberQuery1.data?.status === 200) {
      setData1(memberQuery1?.data?.apiData);
    }
  }, [memberQuery1.data]);

  useEffect(() => {
    if (memberQuery.data?.status === 200) {
      setData(memberQuery?.data?.apiData);
    }
  }, [memberQuery.data]);

  return (
    <>
      <Grid container spacing={2.5} sx={{ my: 1 }}>
        <Grid item sm={12} md={3} xs={12}>
          <CountryWiseMembers
            data={
              data?.countryWiseMemberResult ? data?.countryWiseMemberResult : []
            }
          />
        </Grid>
        <Grid item sm={12} md={3} xs={12}>
          <SkillWiseMembers
            data={
              data?.skillWiseMemberResult ? data?.skillWiseMemberResult : []
            }
          />
        </Grid>
        <Grid item sm={12} md={3} xs={12}>
          <IndividualAnalysisMembers
            data={
              data?.individualAnalysisResult
                ? data?.individualAnalysisResult
                : []
            }
          />
        </Grid>
        <Grid item sm={12} md={3} xs={12}>
          <IndustryWiseMembers
            data={data1?.industryWiseTabularMemberResult || []}
          />
        </Grid>
      </Grid>
    </>
  );
};
export default MemberWiseTables;
